import * as React from 'react';
import { Box, Button, Grid, Chip, Typography, FormControl, InputLabel, Select, MenuItem, } from "@mui/material"
import styleCss from "../Style/style"
import AerrowIcon from "../img/arrowiconsingle.png"
import ShortIcon from "../img/sorticon.png"
import { useState } from "react";
import GiftIcon from '../img/gift-icon.png'
import CloseIcon from '@mui/icons-material/Close';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Fireimg from '../img/fire-icon.png'
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ElectricBoltOutlinedIcon from '@mui/icons-material/ElectricBoltOutlined';
import { Link, useNavigate } from "react-router-dom";
import FrontBusImg from "../img/frontview.jpg"
import InnerBusImg from "../img/innerbus.jpg"
import Stering from "../img/staring.png"
import BusLowerSeatSvg from './BusLowerSeatSvg';
import BusUpperSeatSvg from './BusUpperSeatSvg';
import { useEffect } from 'react';
import dayjs from 'dayjs';
import { AuthAxios } from '../Utilities/CommonAxios';
import showToast from '../Utilities/showToast';
import { encryptData } from '../Utilities/crypto';

const BusSeatsSelection = ({ fromDetails, toDetails, travelDates }) => {
    const navigate = useNavigate()
    const from = JSON.parse(fromDetails);
    const to = JSON.parse(toDetails)
    const travelDate = dayjs(travelDates).format("YYYY-MM-DD")
    const [open, setOpen] = useState(true);
    const [travelDetails, setTravelDetails] = useState([]);
    const [seatLayoutCount, setSeatLayoutCount] = useState("");
    const [seatMappingDetails, setSeatMappingDetails] = useState([])
    const [expanded, setExpanded] = useState(false);
    const [bookedSeat, setBookedSeat] = useState([]);

    const [boardingpoint, setBoardingpoint] = useState([])
    const [droppingpoint, setDroppingpoint] = useState([])
    const [boardingPoint, setBoardingPoint] = useState('');
    const [droppingPoint, setDroppingPoint] = useState('')
    const [operatorId, setOperatorId] = useState('')
    const [selectedDetails, setSelectedDetails] = useState('')
    const [scheduleId, setScheduleId] = useState(0)

    // const handleChange = (event) => {
    //     setBoardingPoint(event.target.value);
    // };

    const travelDetailsApi = async () => {
        try {
            const apiResponse = await AuthAxios({
                url: '/bus_list',
                method: 'post',
                payload: {
                    "origin_boarding_id": from?.boarding_point_id,
                    "origin_city_id": from?.city_id,
                    "destination_boarding_id": to?.boarding_point_id,
                    "destination_city_id": to?.city_id,
                    "date_of_journey": travelDate
                }
            })
            if (apiResponse.status) {
                setTravelDetails(apiResponse?.data)
            } else {
                // showToast('error', apiResponse?.message)
                setTravelDetails([])
            }
        } catch (error) {
            setTravelDetails([])

        }
    }

    const seatLayout = async (scheduleId) => {
        try {

            const apiResponse = await AuthAxios({
                url: '/seat_layouts',
                method: 'post',
                payload: {
                    "schedule_id": scheduleId
                }
            })
            if (apiResponse.status) {
                setSeatLayoutCount(apiResponse?.data[0])
            } else {
                // showToast('error', apiResponse?.message)
                setTravelDetails("")
            }
        } catch (error) {
            setTravelDetails("")

        }
    }


    const seatMapping = async (scheduleId) => {
        try {

            const apiResponse = await AuthAxios({
                url: '/seat_mapp',
                method: 'post',
                payload: {
                    "schedule_id": scheduleId,
                    "origin_city_id": from?.city_id,
                    "destination_city_id": to?.city_id
                }
            })
            if (apiResponse.status) {
                setSeatMappingDetails(apiResponse?.data)
            } else {
                // showToast('error', apiResponse?.message)
                setSeatMappingDetails([])
            }
        } catch (error) {
            setSeatMappingDetails([])

        }
    }


    useEffect(() => {
        travelDetailsApi();

    }, [fromDetails, toDetails, travelDates]);



    const [asc, setAsc] = useState(true);
    const handleSortbyPrice = () => {
        const sorted = [...travelDetails].sort((a, b) => (asc ? a?.minprice ?? 0 - b?.minprice ?? 0 : b?.minprice ?? 0 - a?.minprice ?? 0));
        setTravelDetails(sorted);
        setAsc(!asc)
    }


    const handleAccordionChange = (panel, details, operatorId, scheduleId, event, isExpanded) => {
        setExpanded(isExpanded);
        setExpanded(isExpanded ? panel : false);
        if (isExpanded === true) {
            setScheduleId(scheduleId)
            setSelectedDetails(details)
            setOperatorId(operatorId)
            seatLayout(scheduleId);
            seatMapping(scheduleId);
            boardinganddropping(scheduleId);
        }
    }



    const boardinganddropping = async (scheduleId) => {
        try {
            const boardingapiResponse = await AuthAxios(({
                url: '/schedule_boarding_points',
                method: 'post',
                payload: {
                    "origin_id": from?.city_id,
                    "schedule_id": scheduleId
                }

            }))
            if (boardingapiResponse.status) {
                setBoardingpoint(boardingapiResponse.data || [])
            }
            const droppingapiResponse = await AuthAxios(({
                url: '/schedule_boarding_points',
                method: 'post',
                payload: {
                    "origin_id": to?.city_id,
                    "schedule_id": scheduleId
                }
            }))
            if (droppingapiResponse.status) {
                setDroppingpoint(droppingapiResponse?.data || [])
            }
        } catch (error) {
            showToast('error', error.message)
            setBoardingpoint([])
            setDroppingpoint([])

        }
    }


    const handleSubmit = async () => {
        if (bookedSeat.length === 0) {
            showToast('error', 'select the seat');
        } else if (boardingPoint === '' && droppingPoint === '') {
            showToast('error', 'select the boarding and dropping point');
        } else {
            const apiResponse = await AuthAxios({
                url: '/temp_seat_block',
                method: 'post',
                payload: {
                    "bus_operator_id": operatorId,
                    "origin_id": from?.city_id,
                    "destination_id": to?.city_id,
                    "date_of_journey": travelDate,
                    "schedule_id": scheduleId,
                    "seat_no": bookedSeat.map(s => s.seat_number).join(", ")
                }
            })
            if (apiResponse.status) {
                navigate(`/boardingseat/${encryptData(apiResponse?.track_id)}/${encryptData(JSON.stringify(selectedDetails))}/${encryptData(JSON.stringify(bookedSeat))}/${encryptData(boardingPoint?.boarding_point_id)}/${encryptData(droppingPoint?.boarding_point_id)}/${travelDate}`);
            } else {
                showToast('error', apiResponse.message)
            }
        }

    }


    return (
        <>
            <Grid container spacing={2}>
                <Grid size={{ md: 9, xs: 12 }}>
                    <Typography sx={styleCss.BusesStyle}>
                        {travelDetails.length} Buses found  for {(from?.boarding_point_name).includes(',') ? (from?.boarding_point_name).split(',')[1] : from?.boarding_point_name}
                        <img src={AerrowIcon} alt='' style={{ marginLeft: '10px', marginRight: '10px' }} />
                        {(to?.boarding_point_name).includes(',') ? (to?.boarding_point_name).split(',')[1] : to?.boarding_point_name}
                        <span style={{
                            fontFamily: '"Segoe UI", sans-serif',
                            fontSize: "15px",
                            fontWeight: 600,
                            backgroundColor: "#eceff2",
                            color: '#0e182b',
                            borderRadius: '10px',
                            padding: '3px 15px',
                            marginLeft: '10px',
                        }}>{dayjs(travelDates).format('MMM D, YYYY')}</span>
                    </Typography>
                </Grid>
                <Grid size={{ md: 3, xs: 12 }} sx={{ textAlign: 'end' }}>
                    <Button
                        onClick={handleSortbyPrice}
                        variant="contained" disableElevation sx={{
                            fontSize: '15px',
                            fontWeight: 600,
                            textAlign: 'center',
                            color: '#0e182b',
                            textTransform: 'capitalize',
                            padding: '3px 10px',
                            borderRadius: '8px',
                            border: 'solid 1px #e5e5e5',
                            backgroundColor: '#fff',
                            fontFamily: '"Segoe UI", sans-serif',
                        }}> <img src={ShortIcon} alt='' /> Sort by Price</Button>
                </Grid>
            </Grid>
            {open &&
                <Grid size={{ md: 12, xs: 12 }} sx={{ marginTop: '5px', marginBottom: '15px' }}>
                    <Grid sx={{
                        backgroundColor: '#e5fded', border: 'solid 1px #bbf7d1',
                        borderRadius: '10px', padding: '10px 15px'
                    }}>

                        <Grid container spacing={2} sx={{ display: 'flex', alignItems: 'center', }}>
                            <Grid size={{ md: 1, xs: 12 }}>
                                <img src={GiftIcon} alt="" />
                            </Grid>
                            <Grid size={{ md: 8, xs: 12 }}>
                                <Typography sx={styleCss.LimitedText}>Limited Time Offer! </Typography>
                                <Typography sx={styleCss.FirstBooking}>up to $250 on your first booking with code FIRST250 </Typography>
                            </Grid>
                            <Grid size={{ md: 3, xs: 12 }} sx={{
                                display: 'flex', justifyContent: 'end', "@media (max-width:600px)": {
                                    justifyContent: 'start',
                                },
                            }}>
                                <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography sx={styleCss.CouponCode}>FIRST250</Typography>
                                    <CloseIcon onClick={() => setOpen(false)} fontSize="inherit" sx={{ cursor: 'pointer', color: '#00a546', fontSize: '20px' }} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            }
            <Grid container spacing={2} sx={{
                marginTop: '10px',
                marginBottom: '10px',
            }}>
                <Grid size={{ md: 12, xs: 12 }}>
                    {travelDetails && travelDetails.map((details, i) => (
                        <Accordion
                            key={i}
                            expanded={expanded === i}
                            onChange={(event, isExpanded) => handleAccordionChange(i, details, details?.operator_id, details?.schedule_id, event, isExpanded)}
                            sx={{
                                border: "1px solid #d1d5db",
                                boxShadow: "0 4px 100px 0 rgba(0, 0, 0, 0.05)",
                                overflow: "hidden",
                                padding: "10px 0",
                                marginBottom: "15px",
                                "&:before": { display: "none" },
                                "&.Mui-expanded": {
                                    margin: "0px 0",
                                },
                                "&:first-of-type": {
                                    borderBottomLeftRadius: 10,
                                    borderBottomRightRadius: 10,
                                    borderTopLeftRadius: 10,
                                    borderTopRightRadius: 10,
                                },
                            }}
                        >
                            <AccordionSummary
                                expandIcon={false}
                                sx={{
                                    "& .MuiAccordionSummary-content": {
                                        margin: 0,
                                        flexGrow: 0,
                                        display: "block",
                                        width: "100%",
                                    },
                                }}
                            >
                                <Grid container sx={{ width: "100%", alignItems: 'center' }}>
                                    <Grid size={{ md: 3, xs: 8 }}>
                                        <Typography sx={styleCss.OrangeTravelsStyle}>
                                            {details?.operator_name}
                                        </Typography>
                                        <Typography sx={styleCss.SeaterText}>
                                            {details?.seat_layout_name}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ md: 2, xs: 4 }} sx={{
                                        "@media (max-width:600px)": {
                                            display: 'flex',
                                            justifyContent: 'end'
                                        },
                                    }}>
                                        <Chip
                                            label="★ 4.6"
                                            sx={{
                                                backgroundColor: "#00a546",
                                                color: "#fff",
                                                fontSize: "13px",
                                                height: 22,
                                            }}
                                        />
                                    </Grid>
                                    <Grid size={{ md: 5, xs: 6 }}>
                                        <Chip
                                            sx={{
                                                backgroundColor: "#eafff1",
                                                color: "#019c36",
                                                fontSize: "13px",
                                                padding: '8px 5px',
                                                height: '25px',
                                            }}
                                            label={
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    <img src={Fireimg} alt="Fire" />
                                                    Special Offer
                                                </Box>
                                            }
                                        />
                                        {/* <Chip
                                        sx={{
                                            backgroundColor: "#cfd3ff",
                                            color: "#2f3790",
                                            fontSize: "13px",
                                            padding: '8px 5px',
                                            height: '25px',
                                        }}
                                        label={
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                New bus
                                            </Box>
                                        }
                                    /> */}
                                    </Grid>
                                    <Grid size={{ md: 2, xs: 6 }} sx={{ textAlign: 'end' }}>
                                        <Typography sx={styleCss.CountNumberTotal}>₹{details?.minprice ?? 0}</Typography>
                                        <Typography sx={styleCss.SeatsStyle}>{details?.seat_balance} seats Left</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container sx={{ width: "100%", marginTop: '10px' }}>
                                    <Grid size={{ md: 10, xs: 12 }}>
                                        <Grid sx={{ display: 'flex', alignItems: 'center', gap: 1, marginRight: '15px' }}>
                                            <Typography sx={styleCss.CountNumberTotal}>{details?.trip_start_time ?? "00:00"}</Typography>

                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    width: '100%',
                                                    gap: 1,
                                                }}
                                            >
                                                <Box sx={{ flex: 1, height: '1px', backgroundColor: '#dcdcdc' }} />
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 0.5,
                                                        px: 1,
                                                        borderRadius: '5px',
                                                        backgroundColor: '#f9fafb',
                                                        color: '#717182',
                                                        fontSize: '14px',
                                                        fontFamily: '"Segoe UI", sans-serif',
                                                        fontWeight: 'normal',
                                                    }}
                                                >
                                                    <AccessTimeIcon sx={{ fontSize: 12, color: '#717182', fontFamily: '"Segoe UI", sans-serif', }} />
                                                    7h 15m
                                                </Box>
                                                <Box sx={{ flex: 1, height: '1px', backgroundColor: '#dcdcdc' }} />
                                            </Box>

                                            <Typography sx={styleCss.CountNumberTotal}>{details?.trip_end_time ?? "00:00"}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid size={{ md: 2, xs: 12 }}>
                                        <Button variant="contained" sx={{
                                            padding: '7px 10px',
                                            borderRadius: '7px',
                                            backgroundColor: '#ff5714',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            textAlign: 'center',
                                            color: '#fff',
                                            fontFamily: '"Segoe UI", sans-serif',
                                            textTransform: 'capitalize',
                                            width: '100%',
                                            "@media (max-width:600px)": {
                                                marginTop: '15px',
                                            },
                                        }}>View Seats</Button>
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid sx={{ background: '#dcdcdc', height: '1px', width: '100%', marginTop: '10px', marginBottom: '10px' }}></Grid>
                                </Grid>
                                <Grid container spacing={2} sx={{ marginBottom: '5px' }}>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <Typography sx={{
                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: '12px',
                                            fontWeight: 'normal',
                                            textAlign: 'left',
                                            color: '#717182'
                                        }}>{details?.vehicle_type} <ElectricBoltOutlinedIcon style={{ fontSize: '13px', verticalAlign: 'text-top', marginLeft: '10px' }} /></Typography>
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }} sx={{
                                        display: 'flex', justifyContent: 'end', "@media (max-width:600px)": {
                                            justifyContent: 'start'
                                        },
                                    }}>
                                        <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Grid sx={{ marginRight: '15px' }}>
                                                <Link to={'/'} style={{
                                                    textDecoration: 'unset',
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: '13px',
                                                    fontWeight: 'normal',
                                                    color: '#717182',
                                                }}>Live Tracking</Link>
                                            </Grid>
                                            <Grid>
                                                <Link to={'/'} style={{
                                                    textDecoration: 'unset',
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: '13px',
                                                    fontWeight: 'normal',
                                                    color: '#717182',
                                                }}>Cancellation</Link>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </AccordionSummary>

                            <AccordionDetails
                                sx={{
                                    borderTop: '1px solid #ddd',
                                    backgroundColor: "#fafafa",
                                    fontFamily: "Inter",
                                    fontSize: "14px",
                                    color: "#424242",
                                    padding: '24px 16px 15px',
                                }}
                            >
                                <Box>
                                    <Grid container spacing={2}>
                                        <Grid size={{ md: 8, xs: 12 }}>
                                            <Grid sx={{ display: 'flex', marginBottom: '15px', gap: '2px', flexWrap: 'wrap', }}>
                                                <Grid sx={{ padding: '5px' }}>
                                                    <Box sx={{
                                                        display: 'flex', alignItems: 'center', gap: '5px',
                                                    }}>
                                                        <Box
                                                            sx={{
                                                                width: '12px',
                                                                height: '12px',
                                                                border: '2px solid #019c36',
                                                                borderRadius: '2px',
                                                            }}
                                                        />
                                                        <Typography
                                                            sx={{
                                                                fontFamily: '"Segoe UI", sans-serif',
                                                                fontSize: '13px',
                                                                fontWeight: 'normal',
                                                                color: '#0e182b',
                                                            }}
                                                        >
                                                            Available
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid sx={{ padding: '5px' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                        <Box
                                                            sx={{
                                                                width: '12px',
                                                                height: '12px',
                                                                border: '2px solid #019c36',
                                                                borderRadius: '2px',
                                                                background: '#019c36',
                                                            }}
                                                        />
                                                        <Typography
                                                            sx={{
                                                                fontFamily: '"Segoe UI", sans-serif',
                                                                fontSize: '13px',
                                                                fontWeight: 'normal',
                                                                color: '#0e182b',
                                                            }}
                                                        >
                                                            Selected
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid sx={{ padding: '5px' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                        <Box
                                                            sx={{
                                                                width: '12px',
                                                                height: '12px',
                                                                border: '2px solid #ff24bd',
                                                                borderRadius: '2px',
                                                            }}
                                                        />
                                                        <Typography
                                                            sx={{
                                                                fontFamily: '"Segoe UI", sans-serif',
                                                                fontSize: '13px',
                                                                fontWeight: 'normal',
                                                                color: '#0e182b',
                                                            }}
                                                        >
                                                            Female Available
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid sx={{ padding: '5px' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                        <Box
                                                            sx={{
                                                                width: '12px',
                                                                height: '12px',
                                                                border: '2px solid #0d99ff',
                                                                borderRadius: '2px',
                                                            }}
                                                        />
                                                        <Typography
                                                            sx={{
                                                                fontFamily: '"Segoe UI", sans-serif',
                                                                fontSize: '13px',
                                                                fontWeight: 'normal',
                                                                color: '#0e182b',
                                                            }}
                                                        >
                                                            Male Available
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid sx={{ padding: '5px' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                        <Box
                                                            sx={{
                                                                width: '12px',
                                                                height: '12px',
                                                                border: '2px solid #ff24bd',
                                                                borderRadius: '2px',
                                                                background: '#ebebeb',
                                                            }}
                                                        />
                                                        <Typography
                                                            sx={{
                                                                fontFamily: '"Segoe UI", sans-serif',
                                                                fontSize: '13px',
                                                                fontWeight: 'normal',
                                                                color: '#0e182b',
                                                            }}
                                                        >
                                                            Female Booked
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid sx={{ padding: '5px' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                        <Box
                                                            sx={{
                                                                width: '12px',
                                                                height: '12px',
                                                                border: '2px solid #0d99ff',
                                                                borderRadius: '2px',
                                                                background: '#ebebeb',
                                                            }}
                                                        />
                                                        <Typography
                                                            sx={{
                                                                fontFamily: '"Segoe UI", sans-serif',
                                                                fontSize: '13px',
                                                                fontWeight: 'normal',
                                                                color: '#0e182b',
                                                            }}
                                                        >
                                                            Male Booked
                                                        </Typography>
                                                    </Box>
                                                </Grid>

                                            </Grid>
                                            <Grid container spacing={2}>
                                                <Grid size={{ md: 6, xs: 12 }}>
                                                    <Box sx={{
                                                        border: "solid 1px #d1d5db",
                                                        borderRadius: "10px",
                                                        boxShadow: "0 4px 100px 0 rgba(0, 0, 0, 0.05)",
                                                        backgroundColor: "#fff",
                                                        width: '100%',
                                                    }}>
                                                        <Box sx={{
                                                            background: '#ebedec', padding: '10px',
                                                            borderTopLeftRadius: "10px", borderTopRightRadius: "10px"
                                                        }}>
                                                            <Grid sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                <Grid>
                                                                    <Typography sx={{ color: '#0e182b', fontSize: '15px', fontFamily: '"Segoe UI", sans-serif', fontWeight: '500' }}>Lower Deck</Typography>
                                                                </Grid>
                                                                <Grid>
                                                                    <img src={Stering} alt='' />
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                        <Box sx={{ ackgroundColor: "#fff", padding: '10px' }}>
                                                            <BusLowerSeatSvg seatLayoutCount={seatLayoutCount} seatMappingDetails={seatMappingDetails} setBookedSeat={setBookedSeat} />
                                                        </Box>
                                                    </Box>
                                                </Grid>
                                                <Grid size={{ md: 6, xs: 12 }}>
                                                    <Box sx={{
                                                        border: "solid 1px #d1d5db",
                                                        borderRadius: "10px",
                                                        boxShadow: "0 4px 100px 0 rgba(0, 0, 0, 0.05)",
                                                        backgroundColor: "#fff",
                                                        width: '100%',
                                                    }}>
                                                        <Box sx={{
                                                            background: '#ebedec', padding: '10px',
                                                            borderTopLeftRadius: "10px", borderTopRightRadius: "10px"
                                                        }}>
                                                            <Typography sx={{ color: '#0e182b', fontSize: '15px', fontFamily: '"Segoe UI", sans-serif', fontWeight: '500' }}>Upper Deck</Typography>
                                                        </Box>
                                                        <Box sx={{ ackgroundColor: "#fff", padding: '10px' }}>
                                                            <BusUpperSeatSvg seatLayoutCount={seatLayoutCount} seatMappingDetails={seatMappingDetails} setBookedSeat={setBookedSeat} />
                                                        </Box>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid size={{ md: 4, xs: 12 }} sx={{ display: 'flex', justifyContent: 'end' }}>
                                            <Box sx={{
                                                border: "solid 1px #d1d5db",
                                                borderRadius: "10px",
                                                boxShadow: "0 4px 100px 0 rgba(0, 0, 0, 0.05)",
                                                padding: '15px 0',
                                                backgroundColor: "#fff",
                                                width: '100%',
                                                padding: '15px 10px'
                                            }}>
                                                <Grid size={{ md: 12, xs: 12 }}>
                                                    <Typography sx={styleCss.OrangeTravelsStyle}>
                                                        Booking Details
                                                    </Typography>
                                                </Grid>
                                                <Grid sx={{ background: '#dcdcdc', height: '1px', width: '100%', marginTop: '10px', marginBottom: '10px' }}></Grid>
                                                <Grid size={{ md: 12, xs: 12 }}>
                                                    <Typography sx={{ fontSize: '16px', color: "#0e182b", fontFamily: '"Segoe UI", sans-serif', fontWeight: '500' }}>Selected Seats</Typography>
                                                    <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                                                        {bookedSeat.map((e, i) => (
                                                            <Grid sx={{ marginRight: '10px' }}>
                                                                <Typography sx={styleCss.SeatSelectionstyle}>
                                                                    {e?.seat_number}
                                                                </Typography>
                                                            </Grid>
                                                        ))}
                                                        {/* <Grid sx={{ marginRight: '10px' }}>
                                                            <Typography sx={styleCss.SeatSelectionstyle}>
                                                                U2
                                                            </Typography>
                                                        </Grid>
                                                        <Grid>
                                                            <Typography sx={styleCss.SeatSelectionstyle}>
                                                                L16
                                                            </Typography>
                                                        </Grid> */}
                                                    </Grid>
                                                    <Typography sx={{ color: '#ff5714', fontSize: '13px', fontFamily: '"Segoe UI", sans-serif', marginBottom: '10px', marginTop: '10px' }}>
                                                        {/* 21:30-05-20.Thu 04 Sep A/C Seater / Sleeper(2+1) */}

                                                    </Typography>
                                                </Grid>
                                                <Grid container spacing={2}>
                                                    <Grid size={{ md: 6, xs: 6 }}>
                                                        <img src={FrontBusImg} alt="" style={{
                                                            width: '100%',
                                                            objectFit: 'cover', height: '100px',
                                                            overflow: 'hidden', borderRadius: '10px'
                                                        }} />
                                                    </Grid>
                                                    <Grid size={{ md: 6, xs: 6 }}>
                                                        <img src={InnerBusImg} alt="" style={{
                                                            width: '100%',
                                                            objectFit: 'cover', height: '100px',
                                                            overflow: 'hidden', borderRadius: '10px'
                                                        }} />
                                                    </Grid>
                                                </Grid>
                                                <Grid size={{ md: 12, xs: 12 }} sx={{ marginTop: '15px' }}>
                                                    <Typography sx={styleCss.CommonLabelName
                                                    }>Boarding Points:</Typography>
                                                    <FormControl fullWidth size="small" variant="outlined" sx={{ marginTop: '5px' }}>
                                                        <InputLabel
                                                            id="boarding-points-label"
                                                            sx={{
                                                                color: '#717182',
                                                                fontSize: '14px',
                                                                fontFamily: '"Segoe UI", sans-serif',
                                                            }}
                                                        >
                                                            Boarding Points
                                                        </InputLabel>

                                                        <Select
                                                            labelId="boarding-points-label"
                                                            id="boarding-points-select"
                                                            value={boardingPoint}
                                                            onChange={(e) => setBoardingPoint(e.target.value)}
                                                            label="Boarding Points"
                                                            sx={{
                                                                color: '#1d1d1d',
                                                                fontSize: '14px',
                                                                fontFamily: '"Segoe UI", sans-serif',
                                                            }}
                                                        >
                                                            <MenuItem value="">
                                                                <em style={{ color: '#717182', fontSize: '14px', fontFamily: '"Segoe UI", sans-serif', }}>None</em>
                                                            </MenuItem>
                                                            {boardingpoint && boardingpoint.map((e, i) => (<MenuItem key={i} sx={{ color: '#1d1d1d', fontSize: '14px', fontFamily: '"Segoe UI", sans-serif', }} value={e}>
                                                                {e?.boarding_point_name}
                                                            </MenuItem>
                                                            ))}

                                                            {/* <MenuItem sx={{ color: '#1d1d1d', fontSize: '14px', fontFamily: '"Segoe UI", sans-serif', }} value={20}>
                                                                Twenty
                                                            </MenuItem>
                                                            <MenuItem sx={{ color: '#1d1d1d', fontSize: '14px', fontFamily: '"Segoe UI", sans-serif', }} value={30}>
                                                                Thirty
                                                            </MenuItem> */}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ md: 12, xs: 12 }} sx={{ marginTop: '15px' }}>
                                                    <Typography sx={styleCss.CommonLabelName
                                                    }>Dropping Points:</Typography>
                                                    <FormControl fullWidth size="small" variant="outlined" sx={{ marginTop: '5px' }}>
                                                        <InputLabel
                                                            id="boarding-points-label"
                                                            sx={{
                                                                color: '#717182',
                                                                fontSize: '14px',
                                                                fontFamily: '"Segoe UI", sans-serif',
                                                            }}
                                                        >
                                                            Dropping Points
                                                        </InputLabel>

                                                        <Select
                                                            labelId="boarding-points-label"
                                                            id="boarding-points-select"
                                                            value={droppingPoint}
                                                            onChange={(e) => setDroppingPoint(e.target.value)}
                                                            label="Boarding Points"
                                                            sx={{
                                                                color: '#1d1d1d',
                                                                fontSize: '14px',
                                                                fontFamily: '"Segoe UI", sans-serif',
                                                            }}
                                                        >
                                                            <MenuItem value="">
                                                                <em style={{ color: '#717182', fontSize: '14px', fontFamily: '"Segoe UI", sans-serif', }}>None</em>
                                                            </MenuItem>
                                                            {droppingpoint && droppingpoint.map((e, i) => (
                                                                <MenuItem key={i} value={e} sx={{ color: '#1d1d1d', fontSize: '14px', fontFamily: '"Segoe UI", sans-serif', }} >
                                                                    {e?.boarding_point_name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ md: 12, xs: 12 }}>
                                                    <Button onClick={handleSubmit} variant="contained" sx={{
                                                        padding: '7px 10px',
                                                        borderRadius: '7px',
                                                        backgroundColor: '#ff5714',
                                                        fontFamily: 'SegoeUI',
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                        textAlign: 'center',
                                                        color: '#fff',
                                                        fontFamily: '"Segoe UI", sans-serif',
                                                        textTransform: 'capitalize',
                                                        width: '100%',
                                                        marginTop: '10px',
                                                    }}>Proceed to Book</Button>
                                                </Grid>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Grid>
            </Grid >
        </>
    )
}
export default BusSeatsSelection